import {Component, OnInit, Input} from '@angular/core';
import { DisplayedColumn, SortDirection } from '../mes-dossiers.datasource';

@Component({
    selector: 'jhi-sort-status',
    template: `<div *ngIf="sortKey === cellKey"
                    class="{{ sortDirection === 'asc' ? 'fa fa-fw fa-sort-asc' : 'fa fa-fw fa-sort-desc' }}"
                    aria-hidden="true"
                    title="{{ sortDirection === 'asc' ? 'Trier ' + columnName + ' dans ' + orderLiteral + ' croissant'
                                                      : 'Trier ' + columnName + ' dans ' + orderLiteral + ' décroissant'}}">
                </div>
                <div *ngIf="sortKey !== cellKey"
                     class="fa fa-fw fa-sort"
                     aria-hidden="true"
                     title="{{defaultSortingTitle}}">
                </div>
              `,
    styleUrls: ['./sort-status.component.scss']
})
export class SortStatusComponent implements OnInit {

    @Input()
    sortKey: DisplayedColumn;

    @Input()
    sortDirection: SortDirection;

    @Input()
    cellKey:  string;

    columnName: string;
    orderLiteral = 'l\'ordre';
    defaultSortingTitle = 'Trier par ';

    ngOnInit(): void {
      switch (this.cellKey) {
        case 'description':
          this.columnName = 'le numéro du dossier';
          this.defaultSortingTitle += this.columnName;
          break;
        case 'juridiction':
          this.columnName = 'la juridiction';
          this.defaultSortingTitle += this.columnName;
          break;
        case 'statut':
          this.columnName = 'l\'état du dossier';
          this.defaultSortingTitle += this.columnName;
          break;
        case 'dateModification':
          this.columnName = 'la date de l\'état';
          this.defaultSortingTitle += this.columnName;
          break;
        default:
          this.columnName = 'les actions';
          this.defaultSortingTitle = 'Trier';
      }
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/home/mes-dossiers/sort-status/sort-status.component.ts